<template>
  <div>
    <!--  subtracted sidebar  -->
    <transition name="fade">
      <mini-sidebar
        v-if="subSidebar"
        :state="subSidebar"
        @subOpen="onSubSidebarListen"
      />
    </transition>

    <!--  full sidebar / mobile sidebar  -->
    <transition name="fade">
      <full-sidebar
        v-if="!subSidebar"
        @fullClose="onFullSidebarListen"
      />
    </transition>
  </div>
</template>

<script setup>
  import MiniSidebar from '@/layout/dashboard/partials/sub-sidebar';
  import FullSidebar from '@/layout/dashboard/partials/full-sidebar';
  import { ref } from 'vue';

  const subSidebar = ref(false);

  if (window.innerWidth >= 768 && window.innerWidth <= 1440) {
    subSidebar.value = true;
  }

  function onSubSidebarListen(value) {
    subSidebar.value = value;
  }

  function onFullSidebarListen() {
    if (window.innerWidth >= 768) {
      subSidebar.value = true;
    }
  }
</script>
